<template>

  <article class="card is-insight" :class="classes">

    <header class="card-header">
      <div class="card-header-start">
        <div class="card-header-title">
          {{ title }}
          <div class="tooltip-container">
            <i class="material-icons">&#xE887;</i>
            <div class="tooltip tooltip-top" role="tooltip">
              <div class="tooltip-arrow"></div>
              <div class="tooltip-inner">
                {{ help }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>

    <section class="card-content">
      <div class="content">
        <slot v-if="!error"><!-- [ CONTENT ] --></slot>
        <error-state v-else :type="error" />
      </div>
    </section>

  </article>

</template>

<script>
  import UiCard from './UiCard'

  export default {
    extends: UiCard
  };
</script>

<style lang="scss" scoped>
  .content {
    position: relative;
    height: 100%;
  }
</style>